import type React from 'react'

import css from './styles.module.css'

// Sits next to a report's title: a scheduled crawl found pages that are new,
// gone or redirected since the one before, and this person has not opened the
// report since. The API decides; the dot only draws the answer.
export const UpdateDot: React.FC = () => (
  <span className={css.dot} role="img" aria-label="Updated" />
)
